import { AuthService } from './../../../core/auth.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  locale = 'pl';

  constructor(
    private translate: TranslateService,
    private authService: AuthService
  ) {
    if (this.authService.getCookie('locale')) {
      this.locale = this.authService.getCookie('locale');
    } else if (this.translate.getBrowserLang()) {
      this.locale = this.translate.getBrowserLang();
    }
  }

  ngOnInit() {}
}
